const ISO_CODES_COUNTRIES_CURRENCIES = {
    IN: "INR",
    PK: "PKR",
    TH: "THB",
    AF: "AFN",
    AL: "ALL",
    DZ: "DZD",
    AS: "USD",
    AD: "EUR",
    AO: "AOA",
    AI: "XCD",
    AG: "XCD",
    AR: "ARS",
    AW: "AWG",
    AU: "AUD",
    AT: "EUR",
    AZ: "AZN",
    BS: "BSD",
    BH: "BHD",
    BD: "BDT",
    BB: "BBD",
    BY: "USD",
    BE: "EUR",
    BZ: "BZD",
    BJ: "XOF",
    BT: "BTN",
    BO: "BOB",
    BA: "BAD",
    BW: "BWP",
    BR: "BRL",
    BM: "BMD",
    VG: "USD",
    BN: "BND",
    BG: "EUR",
    BF: "XOF",
    BI: "BIF",
    KH: "USD",
    CM: "XAF",
    CA: "CAD",
    CV: "CVE",
    CF: "XAF",
    TD: "XAF",
    CL: "CLP",
    CN: "CNY",
    CO: "COP",
    KM: "KMF",
    CG: "XAF",
    CD: "USD",
    CK: "NZD",
    CR: "CRC",
    HR: "EUR",
    AN: "ANG",
    CY: "EUR",
    C2: "USD",
    CZ: "CZK",
    DK: "DKK",
    DJ: "DJF",
    DO: "DOP",
    TP: "USD",
    EC: "USD",
    EG: "EGP",
    SV: "USD",
    GQ: "XAF",
    ER: "ERN",
    EE: "EUR",
    ET: "ETB",
    FK: "FKP",
    FJ: "FJD",
    FI: "EUR",
    FR: "EUR",
    GF: "EUR",
    GA: "XAF",
    GM: "GMD",
    GE: "GEL",
    DE: "EUR",
    GH: "GHS",
    GI: "GBP",
    GR: "EUR",
    GD: "XCD",
    GP: "EUR",
    GU: "USD",
    GT: "GTQ",
    GN: "GNF",
    GW: "XOF",
    GY: "GYD",
    HT: "HTG",
    HN: "HNL",
    HK: "HKD",
    HU: "HUF",
    IS: "ISK",
    ID: "IDR",
    IQ: "IQD",
    IE: "EUR",
    IL: "USD",
    IT: "EUR",
    CI: "XOF",
    JM: "JMD",
    JP: "JPY",
    JO: "JOD",
    KZ: "KZT",
    KE: "KES",
    KI: "AUD",
    KR: "USD",
    K1: "EUR",
    KW: "KWD",
    KG: "USD",
    LA: "LAK",
    LV: "EUR",
    LB: "USD",
    LS: "LSL",
    LR: "USD",
    LI: "CHF",
    LT: "EUR",
    LU: "EUR",
    MO: "MOP",
    MK: "EUR",
    MG: "MGA",
    MW: "MWK",
    MY: "MYR",
    MV: "MVR",
    ML: "XOF",
    MT: "EUR",
    MH: "USD",
    MQ: "EUR",
    MR: "MRO",
    MU: "MUR",
    YT: "EUR",
    MX: "MXN",
    FM: "USD",
    MD: "MDL",
    MC: "EUR",
    MN: "USD",
    ME: "EUR",
    MS: "XCD",
    MA: "MAD",
    MZ: "MZN",
    MM: "MMK",
    NA: "NAD",
    NR: "AUD",
    NP: "NPR",
    NL: "EUR",
    NC: "XPF",
    NG: "NGN",
    NZ: "NZD",
    NI: "USD",
    NE: "XOF",
    NU: "NZD",
    MP: "USD",
    NO: "NOK",
    OM: "OMR",
    PW: "USD",
    PS: "ILS",
    PA: "USD",
    PG: "PGK",
    PY: "PYG",
    PE: "PEN",
    PH: "PHP",
    PL: "PLN",
    PT: "EUR",
    PR: "USD",
    QA: "QAR",
    RE: "EUR",
    RO: "RON",
    RU: "RUR",
    RW: "RWF",
    BL: "EUR",
    KN: "XCD",
    LC: "XCD",
    VC: "XCD",
    WS: "WST",
    ST: "STN",
    SA: "SAR",
    SN: "XOF",
    YU: "RSD",
    SC: "SCR",
    SL: "SLE",
    SG: "SGD",
    SK: "EUR",
    SI: "EUR",
    SB: "SBD",
    ZA: "ZAR",
    SS: "SSP",
    ES: "EUR",
    LK: "LKR",
    S1: "ANG",
    SD: "SDG",
    SR: "USD",
    SE: "SEK",
    CH: "CHF",
    TW: "USD",
    TJ: "USD",
    TZ: "TZS",
    TG: "XOF",
    TO: "TOP",
    TT: "TTD",
    TN: "TND",
    TR: "TRY",
    TM: "USD",
    TV: "AUD",
    UG: "UGX",
    UA: "UAH",
    AE: "AED",
    GB: "GBP",
    US: "USD",
    UY: "UYP",
    UZ: "USD",
    VU: "VUV",
    VE: "VIB",
    VN: "VND",
    VI: "USD",
    YE: "USD",
    ZM: "ZMW",
    ZW: "USD",
    QS: "USD",
    CU: "USD",
    TC: "USD",
    XR: "GBP",
    QQ: "USD",
    XP: "USD",
    AB: "USD",
    QM: "USD",
    QN: "USD",
    QO: "USD",
    QP: "USD",
    QR: "USD",
    QT: "USD",
    QU: "USD",
    QV: "USD",
    QW: "USD",
    QX: "USD",
    QY: "USD",
    QZ: "USD",
    XF: "USD",
    XY: "USD",
    XN: "USD",
    XT: "USD",
    KY: "KYD",
    DM: "XCD",
    ST: "STN"
};
